export default __webpack_public_path__ + "static/media/loader.0b5bed3f.svg";